import ContainerDialog from './ContainerDialog'

import Confirm from './Confirm'
import Prompt from './Prompt'
import Alert from './Alert'

const Plugin = {
    install(Vue, options = {}) {
        /**
         * Makes sure that plugin can be installed only once
         */
        if (this.installed) {
            return
        }

        this.installed = true
        this.event = new Vue()
        this.rootInstance = null

        Vue.component('ContainerDialog', ContainerDialog)

        Vue.prototype.$dialogs = {
            show(modal, ...args) {
                return Plugin.rootInstance.show(modal, ...args)
            },

            showComponent(modal, ...args) {
                return Plugin.rootInstance.showComponent(modal, ...args)
            },

            hide(name, params) {
                Plugin.event.$emit('toggle', name, false, params)
            },
            toggle(name, params) {
                Plugin.event.$emit('toggle', name, undefined, params)
            },

            /*shortcuts*/
            confirm(...args) {
                return Plugin.rootInstance.show(Confirm, ...args)
            },
            confirmDelete(...args) {
                let params = {variant: 'danger', okTitle: 'DELETE', ...args[0]}
                return Plugin.rootInstance.show(Confirm, params)
            },
            prompt(...args) {
                return Plugin.rootInstance.show(Prompt, ...args)
            },
            alert(...args) {
                return Plugin.rootInstance.show(Alert, ...args)
            }
        }
    }
}

export default Plugin
